import { forwardRef } from "react";

import { twMerge } from "tailwind-merge";

import InlineError from "../inlineerror";

type ControlledProps = {
  defaultValue?: undefined;
  value: string;
  onChange: (text: string) => void;
};

type UncontrolledProps = {
  defaultValue?: string;
  value?: undefined;
  onChange?: undefined;
};

type DefaultProps = {
  autoFocus?: boolean;
  label?: string;
  placeholder?: string;
  name?: string;
  error?: string;
  type?: "text" | "password" | "email" | "number";
  className?: string;
};

type Props = DefaultProps & (ControlledProps | UncontrolledProps);

const TextInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  return (
    <div className="w-full">
      <div className="flex w-full flex-col gap-1">
        {props.label && (
          <label className="text-sm leading-6 text-gray-600">
            {props.label}
          </label>
        )}
        <input
          ref={ref}
          autoFocus={props.autoFocus}
          value={props.value}
          placeholder={props.placeholder}
          defaultValue={props.defaultValue}
          onChange={(e) => props.onChange && props.onChange(e.target.value)}
          name={props.name}
          className={twMerge(
            "text-md flex-1 rounded-md border-0 px-3 py-0.5 text-sm leading-loose shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600",
            props.error ? "text-red-600" : "text-gray-900",
            props.className || "",
          )}
          aria-invalid={props.error ? true : undefined}
          aria-errormessage={props.error ? props.name + "-error" : undefined}
          type={props.type || "text"}
        />
      </div>
      {props.error && <InlineError error={props.error} />}
    </div>
  );
});

TextInput.displayName = "TextInput";

export default TextInput;
